'use client'
import { SectionContent } from "@/types/sections.model";
import { Box, Container, Grid, Typography } from "@mui/material";
import FadeIn from "@/components/ui/FadeIn";
import Row from "../ui/Row";
import { useWindowSize } from "@/hook/useWindowSize";
import Media from "../ui/Media";

const MediaGrid: React.FC<{ section: SectionContent<'media-grid'> }> = ({ section }) => {

  const { id, content, items } = section;
  const { isMobile } = useWindowSize()
  return (
    <>
      <Box id={id} pt={{xs: 32, lg: 48}}>
        <Container>
          <Row justifyContent={'center'}>

            {(content.title || content.subtitle) && (
              <Grid size={{xs: 12, lg: 8}} textAlign={"center"}>
                <FadeIn>
                  {content.title && (
                    <Typography variant="displaySM" component={"h2"} mb={12} >{content.title}</Typography>
                  )}
                  {content.subtitle && (
                    <Typography variant="headlineMDMedium" component={"p"} mb={{xs: 12, lg: 24}}>{content.subtitle}</Typography>
                  )}
                </FadeIn>
              </Grid>
            )}

            {items.map((item, index) => (
              <Grid key={index} size={{xs: 6, lg: 5}} textAlign={"center"}>
                <FadeIn transition={{ delay: isMobile ? 0 : index * 0.2 }}>
                  {/* <Image
                    src={item.source}
                    alt={item.title}
                    width={494}
                    height={741}
                    style={{ width: '100%', height: 'auto' }}
                  /> */}
                  <Media item={item} />
                </FadeIn>
              </Grid>
            ))}

            {content.caption &&(
              <Grid size={{xs: 12, lg: 8}} textAlign={"center"}>
                <FadeIn>
                  <Typography variant="headlineSMMedium" component={"p"} mt={{xs: 12, lg: 24}}>{content.caption}</Typography>
                </FadeIn>
              </Grid>
            )}
          </Row>
        </Container>
      </Box>
    </>
  )
}

export default MediaGrid;